var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 113.55 108.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23097"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23096"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15804",
    d: "m46.73,85.3c-1.67,6.92-5.28,13.21-10.41,18.15h40.88c-5.12-4.94-8.74-11.23-10.41-18.15h-20.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15805",
    d: "m85.59,105.86H27.96c-.67-.02-1.22.51-1.24,1.18-.02.66.51,1.22,1.17,1.24h57.7c.67-.02,1.19-.58,1.17-1.24-.02-.64-.53-1.16-1.17-1.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15806",
    d: "m0,75.88c0,3.87,3.14,7,7.01,7.01h99.51c3.88,0,7.02-3.13,7.03-7.01v-10.25H0v10.25Zm53.58-3.99h6.39c1.31-.03,2.4,1.01,2.42,2.32s-1.01,2.4-2.32,2.42h-6.49c-1.31.03-2.4-1.01-2.42-2.32s1.01-2.4,2.32-2.42h.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15807",
    d: "m106.52,0H7.01C3.14,0,0,3.13,0,7v56.21h113.55V6.93C113.51,3.08,110.37,0,106.52,0m-63.56,37.36c0,3.89-1.35,7.65-3.83,10.64-.34.41-.7.81-1.08,1.19-.38.38-.78.74-1.19,1.08-.36.3-.74.58-1.12.85-.34.23-.68.46-1.04.67-2.57,1.52-5.5,2.32-8.48,2.32-.52,0-1.04-.03-1.55-.08-.15-.01-.3-.03-.45-.05-.37-.04-.74-.1-1.11-.17-.09-.02-.18-.02-.27-.04-.05-.01-.11-.03-.16-.04-.49-.1-.97-.22-1.45-.37-.41-.13-.81-.28-1.2-.44-.11-.04-.23-.08-.34-.12-.21-.09-.42-.2-.63-.3-.28-.13-.57-.26-.84-.4-.38-.21-.74-.44-1.11-.67-.09-.06-.19-.11-.28-.17-.2-.14-.4-.29-.59-.44s-.38-.27-.56-.42c-.04-.04-.09-.07-.14-.1s-.07-.06-.1-.09c-.36-.3-.7-.61-1.04-.94-.05-.05-.11-.11-.16-.17-.3-.31-.59-.63-.87-.96-.03-.04-.07-.08-.1-.11-.02-.02-.03-.04-.04-.06-.3-.36-.58-.74-.84-1.13-.06-.08-.11-.17-.17-.25-.23-.34-.44-.7-.64-1.06-.03-.06-.08-.11-.11-.17-.24-.45-.46-.91-.66-1.38h0c-.23-.54-.44-1.09-.62-1.65-.02-.07-.04-.14-.06-.2-.09-.29-.16-.59-.24-.89-.03-.11-.05-.22-.07-.33-.06-.26-.11-.53-.15-.8-.02-.13-.04-.25-.06-.38-.04-.27-.07-.54-.09-.82-.01-.12-.03-.24-.03-.36-.03-.39-.04-.78-.04-1.18,0-2.99.79-5.92,2.31-8.5.21-.36.43-.7.67-1.04.27-.39.55-.76.85-1.12,1.37-1.66,3.05-3.05,4.95-4.08,2.13-1.16,4.49-1.84,6.92-1.99.36-.02.71-.03,1.08-.03.67,0,1.21.54,1.21,1.21v14.38h14.33c.66,0,1.2.52,1.21,1.18,0,0,0,.02,0,.02m8.74-8.19s-.04.05-.05.08c-.04.07-.08.14-.13.2-.02.03-.04.06-.06.09h0c-.08.07-.16.13-.25.18-.04.03-.08.06-.13.09-.03.01-.07.01-.1.02-.12.04-.24.07-.36.08h-15.57c-.66,0-1.2-.52-1.21-1.18v-15.59c0-.66.52-1.2,1.18-1.21h.03c.52,0,1.03.03,1.54.08.15.01.3.03.45.05.37.04.74.1,1.11.17.09.02.18.02.27.04.05.01.11.03.16.04.49.1.97.22,1.44.37s.93.32,1.39.51c.14.05.27.12.4.17.33.15.66.3.97.47.13.07.26.13.38.2.42.24.84.48,1.24.76.34.23.66.48.98.74.1.08.21.15.3.23.14.11.26.24.4.36h0c.27.23.54.47.79.72.06.06.1.12.16.18.32.33.63.66.92,1.01.34.41.66.84.96,1.29,1.22,1.81,2.08,3.85,2.52,5.99.11.55.2,1.11.25,1.66.06.57.09,1.14.09,1.71,0,.16-.03.32-.09.47m21.29,24.05c0,1.33-1.08,2.41-2.41,2.41s-2.41-1.08-2.41-2.41V13.75c0-1.33,1.08-2.41,2.41-2.41s2.41,1.08,2.41,2.41h0v39.47Zm9.83.58c-.37,1.33-1.75,2.1-3.08,1.73-.84-.24-1.49-.89-1.73-1.73v-29.98c.38-1.33,1.76-2.1,3.09-1.72.84.24,1.49.89,1.72,1.72v29.98Zm9.83-.58c0,1.33-1.08,2.41-2.41,2.41s-2.41-1.08-2.41-2.41h0V13.75c0-1.33,1.08-2.41,2.41-2.41s2.41,1.08,2.41,2.41v39.47Zm9.83.58c-.38,1.33-1.76,2.1-3.09,1.73-.84-.24-1.49-.89-1.73-1.73v-29.98c.38-1.33,1.76-2.1,3.09-1.73.84.24,1.49.89,1.73,1.73v29.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15808",
    d: "m17.13,51.41c.36.23.72.46,1.1.67.27.15.55.27.83.4-.67-.31-1.31-.67-1.93-1.07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15809",
    d: "m10.81,43.94c-.23-.54-.43-1.09-.61-1.65.17.56.38,1.11.61,1.65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15810",
    d: "m11.47,45.33c.03.06.07.12.11.18-.28-.5-.54-1.02-.77-1.55.2.47.42.93.66,1.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15812",
    d: "m18.23,52.08c.27.15.56.27.84.4-.28-.13-.56-.26-.83-.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15813",
    d: "m17.12,51.41c.36.23.73.47,1.11.67-.38-.2-.74-.43-1.1-.67h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15814",
    d: "m16.25,50.8c.2.15.39.3.59.44-.2-.14-.39-.29-.59-.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15815",
    d: "m47.04,17.03c-.06-.06-.1-.12-.16-.18-.25-.25-.52-.48-.79-.72.33.29.64.58.95.89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15817",
    d: "m46.88,16.85c-.25-.25-.52-.48-.79-.72.27.23.54.47.79.72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15818",
    d: "m13.28,48s.07.08.1.11c-.05-.06-.1-.11-.15-.17.02.02.03.04.04.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15819",
    d: "m15.45,50.18s.07.06.1.09.09.07.14.1c-.08-.06-.16-.13-.24-.19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15820",
    d: "m20.03,52.91c.39.16.79.31,1.2.44-.03,0-.05-.02-.08-.03-.38-.12-.75-.27-1.12-.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15821",
    d: "m19.07,52.49c.21.1.41.21.62.3.11.05.23.08.34.12-.33-.13-.65-.28-.97-.43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15822",
    d: "m19.06,52.48c.21.1.41.21.63.3-.21-.09-.42-.2-.62-.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15823",
    d: "m16.84,51.24h0c.06.04.13.08.2.12-.07-.04-.14-.08-.2-.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15824",
    d: "m16.84,51.24c.09.06.19.11.28.17-.03-.02-.05-.03-.08-.05-.07-.04-.14-.08-.2-.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15825",
    d: "m15.55,50.28s.09.07.14.1c-.04-.04-.09-.07-.14-.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15826",
    d: "m50.96,29.84s.07-.01.1-.02c.04-.03.09-.06.13-.09-.07.04-.15.08-.23.11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15827",
    d: "m45.69,15.78c-.1-.08-.21-.15-.3-.23.24.19.47.39.7.59-.13-.12-.26-.25-.39-.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15828",
    d: "m46.09,16.13c-.13-.12-.26-.25-.4-.36.14.11.26.24.39.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15829",
    d: "m51.7,29.17c.06-.15.09-.31.09-.47,0,.08-.02.16-.04.23,0,.08-.02.16-.04.23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15830",
    d: "m51.45,25.33c-.22-1.08-.55-2.13-.98-3.15.21.5.4,1.01.56,1.54s.3,1.06.41,1.61"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15831",
    d: "m21.23,53.35c.47.15.96.27,1.45.37-.52-.11-1.02-.24-1.52-.4.03,0,.05.02.08.03"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15832",
    d: "m19.69,52.79c.11.05.23.08.34.12-.11-.04-.23-.08-.34-.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15833",
    d: "m20.03,52.91h0c.37.15.74.29,1.12.41-.38-.12-.76-.27-1.12-.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15834",
    d: "m42.96,37.36c0,3.89-1.36,7.65-3.83,10.64,2.48-2.99,3.83-6.76,3.83-10.65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15835",
    d: "m22.84,53.76c.09.02.18.03.27.04-.15-.03-.29-.05-.44-.08.05.01.11.03.16.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15836",
    d: "m40.02,12.69c-.47-.15-.96-.27-1.44-.37.97.21,1.91.5,2.83.88-.45-.19-.91-.36-1.39-.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15837",
    d: "m51.2,29.72c.09-.05.17-.1.25-.17h0c-.08.06-.16.12-.25.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15840",
    d: "m51.07,29.81s.09-.06.13-.09c-.04.03-.08.06-.12.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15841",
    d: "m51.19,29.73c.09-.05.18-.11.25-.17-.07.07-.16.12-.25.17h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15842",
    d: "m38.41,12.28c-.09-.02-.18-.03-.27-.04.15.03.29.05.43.08-.05-.01-.11-.03-.16-.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15843",
    d: "m51.64,29.25s.04-.05.05-.08c.02-.08.04-.15.04-.23-.02.11-.06.22-.1.32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15844",
    d: "m51.64,29.25s.04-.05.05-.08c-.01.03-.04.05-.05.08"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15845",
    d: "m51.45,29.55s.04-.06.06-.09c-.02.03-.04.06-.06.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15846",
    d: "m51.51,29.45c.05-.06.09-.13.13-.2-.04.07-.08.14-.13.2"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboards);
export default __webpack_public_path__ + "static/media/Dashboards.612a947e845cdf5948e8c37e42cad5fc.svg";
export { ForwardRef as ReactComponent };